import { Card, List, Tag, Typography } from 'antd';
import { findGlossaryHits } from '@/lib/glossary-hints';
import type { GlossaryTerm } from '@/types/glossary';

const { Text } = Typography;

interface OtherLangValue {
  lang_code: string;
  value: string;
}

interface Props {
  sourceText: string;
  glossary: GlossaryTerm[];
  targetLang: string;
  otherLangs: OtherLangValue[];
}

export function KeyReferenceColumn({ sourceText, glossary, targetLang, otherLangs }: Props) {
  const hits = findGlossaryHits(sourceText, glossary, targetLang);

  return (
    <>
      <Card title="Glossary hints" size="small" style={{ marginBottom: 12 }}>
        {hits.length === 0 && (
          <Text type="secondary">No glossary terms in this source string.</Text>
        )}
        <List
          dataSource={hits}
          renderItem={(h) => (
            <List.Item style={{ padding: '6px 0' }}>
              <code>{h.term}</code>
              {h.preserve_as_is ? (
                <Tag color="blue" style={{ marginLeft: 8 }}>
                  preserve as-is
                </Tag>
              ) : h.translation ? (
                <span>
                  {' '}
                  → <code>{h.translation}</code>
                </span>
              ) : (
                <Tag color="warning" style={{ marginLeft: 8 }}>
                  no translation set
                </Tag>
              )}
            </List.Item>
          )}
        />
      </Card>

      <Card title="Other languages (read-only)" size="small">
        {otherLangs.length === 0 && (
          <Text type="secondary">No other languages have a value for this key.</Text>
        )}
        <List
          dataSource={otherLangs}
          renderItem={(o) => (
            <List.Item style={{ padding: '6px 0', display: 'block' }}>
              <Tag>{o.lang_code}</Tag>
              <div style={{ marginTop: 4, fontSize: 13 }}>{o.value}</div>
            </List.Item>
          )}
        />
      </Card>
    </>
  );
}
